export default {
  yes: 'yes',
  no: 'no',
  all: 'All',
  equals: 'equals',
  in: 'in',
  notIn: 'notIn',
  lt: 'lt',
  lte: 'lte',
  gt: 'gt',
  gte: 'gte',
  not: 'not',
  contains: 'contains',
  startsWith: 'startsWith',
  endsWith: 'endsWith',
  addFilter: 'Add a new filter',
  nonFilterMsg: 'Use filters to narrow down your data. Multiple filters show results at their intersection (AND).',
  deleteConfirm: 'Are you sure you want to delete this record ?',
  select: 'Select',
  actions: 'Actions',
  relation: 'Relation',
  viewAll: 'View All',
  viewRelated: 'View Related',
  connected: 'Connected',
  connect: 'Connect',
  disConnect: 'DisConnect',
  editRow: 'Edit Row',
  viewRow: 'View Row',
  deleteRow: 'Delete Row',
  showing: 'Showing',
  of: 'of',
  results: 'results',
  goToFirstPage: 'Go to first page',
  goToLastPage: 'Go to last page',
  goPageNumber: 'Go Page Number',
  setPageSize: 'Set page size ',
  filter: 'Filter',
  save: 'Save',
  cancel: 'Cancel',
  close: 'Close',
  create: 'Create',
  update: 'Update',
  view: 'View',
  isRequired: ' is required',
  show: 'SHOW',
};
